export const gitCommit = 'db6da1ca'
